/**
 * @aurora-catalyst-generated
 * @source cliter/packages
 *
 * Composed from the installed package manifests on every render. Register project entries in
 * project.composition.ts instead of editing this file.
 */
import type { EnvironmentProviders, Provider } from '@angular/core';
import { CustomFieldCatalogService } from '@aurora/components/custom-field-capture-form/custom-field-catalog.service';
import { CurrentAccountService } from '@aurora/modules/authentication';
import { HelpAssistantEntry } from '@aurora/modules/manual';
import { CurrentAccountIamAdapter } from './domains/admin/apps/iam/account/adapters';
import { ToolsHelpAssistantEntry } from './domains/admin/apps/tools/assistant/tools-help-assistant-entry';
import { CustomFieldCatalogToolsAdapter } from './domains/admin/apps/tools/custom-field-definition/data-access/custom-field-catalog.adapter';
import { projectProviders } from './project.composition';
/**
 * One provider per framework port that the scaffold or a package binds. The scaffold's default
 * adapter stays until a package binds the token. The project's own providers come from
 * `project.composition.ts` last, so they win (Angular resolves a token to its last provider).
 */
export const auroraPortProviders: Array<EnvironmentProviders | Provider> = [
  { provide: CurrentAccountService, useClass: CurrentAccountIamAdapter },
  { provide: CustomFieldCatalogService, useClass: CustomFieldCatalogToolsAdapter },
  { provide: HelpAssistantEntry, useClass: ToolsHelpAssistantEntry },
  ...projectProviders,
];
